import { Column } from "@faire/web/slate/Layout";
import { LoadingSkeleton } from "@faire/web/slate/LoadingSkeleton";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";

export const GridV2ProductTilePlaceholder = () => {
  return (
    <Column>
      <LoadingSkeleton
        width={{
          mobileAndAbove: 286,
          tabletAndAbove: 290,
          desktopAndAbove: 312,
        }}
        height=""
        aspectRatio="1"
      />
      <Column>
        <Spacer height="1x" />
        <LoadingSkeleton width="100%" height="16px" />
        <Spacer height="1x" />
        <LoadingSkeleton width="75%" height="16px" />
        <Spacer height="1x" />
      </Column>
    </Column>
  );
};

export const GridV2BrandTilePlaceholder = () => {
  return (
    <Column>
      <LoadingSkeleton
        width={{
          mobileAndAbove: 384,
          tabletAndAbove: 514,
          desktopAndAbove: 492,
        }}
        height=""
        aspectRatio="1"
      />
      <Column>
        <Spacer height="1x" />
        <LoadingSkeleton width="100%" height="16px" />
        <Spacer height="1x" />
        <LoadingSkeleton width="100%" height="16px" />
        <Spacer height="1x" />
      </Column>
    </Column>
  );
};

export const GridV2GenericTilePlaceholder = () => {
  return (
    <Column>
      <LoadingSkeleton width="100%" height="" aspectRatio="1" />
      <Column>
        <Spacer height="1x" />
        <LoadingSkeleton width="80%" height="16px" />
        <Spacer height="1x" />
      </Column>
    </Column>
  );
};
